<template>
    <div class="regEmail clear">
        <div class="reg_l page_l">
        </div>
        <div class="reg_r page_r">
            <div class="main">
                <div class="content">
                    <div class="reg_header">
                        <h1 class="title">同济邮箱</h1>
                        <p>请进行邮箱注销</p>
                    </div>
                    <div class="regForm">
                        <Form></Form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Form from './form'
export default {
    name: 'blockOfficialEmail',
    components: {
      Form
    },
    data(){
        return{
          
        }
    }
    
}
</script>

<style scoped>
.regEmail{
    width: 100%;
}
.page_l{
    background: url("../../../assets/img/bigBg/reg_bg.jpg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}
.page_r .main .content{
    width: 480px;
    height: 380px;
    margin: 0 auto;
    padding-right: 25px;
  position: absolute;
  left: 50%;
  top:50%;
  margin-left: -251px;
  margin-top: -190px;
  background: #fff;
  border-radius: 10px 10px 0 0;
  /* box-shadow: -60px 0 100px -70px #027AEA; */
    -webkit-box-shadow:0 0 30px #027AEA;  

  -moz-box-shadow:0 0 30px #027AEA;  

  box-shadow:0 0 30px #027AEA; 
}
.home_titile h3{
    font-weight: 600;
    font-size:28px;
    color:#1c1c1c;
}

.reg_header{
    width: 505px;
    font-weight: 600;
    text-align: center;
    margin-top: 25px;
}
.reg_header .title{
    font-size: 26px;
    color: #f25170;
}
.reg_header p{
    font-size: 15px;
    color: #242c3f;
    
}

</style>




// WEBPACK FOOTER //
// src/page/Coremail/block/index.vue